// generated by srcset-codegen
import src from "./instagram.png";
import src2x from "./instagram@2x.png";
import src3x from "./instagram@3x.png";

const width = 16;
const height = 16;
const srcSet = `${src2x} 2x, ${src3x} 3x`;
export default { src, width, height, srcSet };
